import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import axios from "axios";

const BASE_URL = "https://moga-dev.com/api";

export const fetchProductsByCategory = createAsyncThunk(
  "productsByCategory/fetchProductsByCategory",
  async ({ categoryId, sortId }, { rejectWithValue }) => {
    try {
      const sortUrl = `${BASE_URL}/products/${sortId}`;
      const response = await axios.get(`${BASE_URL}/products/category/${categoryId}`);

      let products = response.data.data || [];
      const totalProductCount = products.length;

      const sortedResponse = await axios.get(sortUrl);
      const sortedProductIds = sortedResponse.data.data.map((p) => p.id);

      products.sort((a, b) => sortedProductIds.indexOf(a.id) - sortedProductIds.indexOf(b.id));

      const topProducts = products.slice(0, 8); // 👈 first 8 products

      return {
        categoryId,
        products,       // full sorted list
        topProducts,    // 👈 first 8 products
        totalCount: totalProductCount,
        totalPages: 1,
      };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch products");
    }
  }
);

const productsByCategorySlice = createSlice({
  name: "productsByCategory",
  initialState: {
    categoryProducts: {},
    loading: false,
    error: null,
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    sortId: "recent-to-old",
    itemsPerPage: 12, // 🆕 added
  },
  reducers: {
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setSort: (state, action) => {
      state.sortId = action.payload;
      state.currentPage = 1;
    },
    // 🆕 New reducers:
    increaseItemsPerPage: (state, action) => {
      const increment = action.payload || 12; // default +10
      state.itemsPerPage += increment;
    },
    decreaseItemsPerPage: (state, action) => {
      const decrement = action.payload || 12; // default -10
      state.itemsPerPage = Math.max(12, state.itemsPerPage - decrement); // min 10
    },
    setItemsPerPage: (state, action) => {
      state.itemsPerPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductsByCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductsByCategory.fulfilled, (state, action) => {
        const { categoryId, products, topProducts, totalPages, totalCount } = action.payload;
        state.loading = false;
        state.categoryProducts[categoryId] = { products, topProducts, totalCount };
        state.totalPages = totalPages;
        state.totalCount = totalCount;
      })
      .addCase(fetchProductsByCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setPage, setSort, increaseItemsPerPage, decreaseItemsPerPage, setItemsPerPage } = productsByCategorySlice.actions;
export default productsByCategorySlice.reducer;
